export const TEXT_ALIGNMENT_LEFT = 0;
export const TEXT_ALIGNMENT_CENTER = 1;

export const TEXT_ALIGNMENT_CLASS_NAMES = {
  [TEXT_ALIGNMENT_LEFT]: 'left',
  [TEXT_ALIGNMENT_CENTER]: 'center',
};



// WEBPACK FOOTER //
// ./app/constants/text-alignment.js